/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import {
    Box,
    Card,
    CardContent,
    Grid,
    Paper,
    Popover,
    Skeleton,
    Stack,
    Typography,
} from "@mui/material";
import Heading from "../heading";
import { useDispatch, useSelector } from '../../redux/store'
import { getOurServiceList } from '../../redux/slices/common';
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import ChauffeurForm from '../../components/all-services/chauffeur';

// const SERVICES = [
//     { title: "Rides", img: "/img/ourservices/rides.svg" },
//     { title: "School & Office\nSubscription", img: "/img/ourservices/school-office.svg" },
//     { title: "Hourly", img: "/img/ourservices/hourly.svg" },
//     { title: "Your Personal\nChauffeur", img: "/img/ourservices/chauffeur.svg" },
//     { title: "Car Rental", img: "/img/ourservices/rental.svg" },
//     { title: "Activities", img: "/img/ourservices/activities.png" },
//     { title: "Packages", img: "/img/ourservices/packages.svg" },
//     { title: "Visa", img: "/img/ourservices/visa.svg" },
// ];

export default function OurServices({ scrollToHero }) {
    const dispatch = useDispatch();
    const router = useRouter();
    const { getOurServiceListRes } = useSelector(
        state => state.common
    );
    const [serviceList, setServiceList] = useState([]);
    const [openEnquire, setOpenEnquire] = useState(false);
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        setLoader(true);
        dispatch(getOurServiceList());
    }, [dispatch])

    // handle response
    useEffect(() => {
        if (!getOurServiceListRes) return;      // wait until we have a response
        setLoader(false);                        // stop loading no matter success/fail

        if (getOurServiceListRes.status === 1) {
            setServiceList(getOurServiceListRes.responseData?.ourServiceList ?? []);
        } else {
            setServiceList([]);
        }
    }, [getOurServiceListRes]);

    const handleCloseEnquire = () => setOpenEnquire(false)

    return (
        <>
            <Box
                sx={{
                    pt: { xs: 2, md: 3 },
                    pb: { xs: 4, md: 4 },
                    position: "relative",
                    maxWidth: "800px",
                    margin: "auto",
                    //         backgroundImage:
                    //             `radial-gradient(#e9edf1 1px, transparent 1px),
                    //    radial-gradient(#e9edf1 1px, transparent 1px)`,
                    // backgroundPosition: "0 0, 12px 12px",
                    // backgroundSize: "24px 24px",
                }}
            >
                {/* Heading */}
                {/* <Heading title="Our Services" subtitle="Looking for something?" /> */}
                <Heading title="Our Services" />

                {/* Cards */}
                {/* tighter gutters between cards */}
                {
                    loader ? <Grid container spacing={3}>
                        {Array.from({ length: 8 }).map((_, i) => (
                            <Grid key={i} item xs={6} sm={4} md={3}>
                                <ServiceCardSkeleton />
                            </Grid>
                        ))}
                    </Grid> : <Grid
                        container
                        spacing={{ xs: 1, sm: 1.25, md: 3 }}   // one knob for both row + col gaps
                        sx={{ maxWidth: 1100, mx: "auto" }}
                    >
                        {serviceList?.map((s, i) => (
                            <Grid key={i} item xs={6} sm={4} md={3}>
                                <ServiceImageCard openEnquire={openEnquire} setOpenEnquire={setOpenEnquire} imgSrc={`${process.env.IMAGE_BASE_URL}/${s?.webImage}`} disable={s?.name === "Car Rental"} target={s?.target} router={router} scrollToHero={scrollToHero} href={s?.href} title={s?.name} />
                            </Grid>
                        ))}
                    </Grid>
                }



            </Box>
            <ChauffeurForm open={openEnquire} setOpen={setOpenEnquire} onClose={handleCloseEnquire} />
        </>
    );
}

function ServiceCardSkeleton() {
    return (
        <Box>
            <Card
                elevation={0}
                sx={{
                    borderRadius: 3,
                    bgcolor: "#f3f6f6",
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}
            >
                {/* Image / illustration area */}
                <Box sx={{ mb: 1.5 }}>
                    <Skeleton
                        animation="wave"
                        variant="rounded"
                        sx={{ borderRadius: 3 }}
                        width="100%"
                        height={120}
                    />
                </Box>

                {/* Title (can be 1–2 lines) */}
                <CardContent sx={{ pt: 0 }}>
                    <Skeleton animation="wave" variant="text" height={20} width="80%" sx={{ mx: "auto", mb: 0.5 }} />
                    <Skeleton animation="wave" variant="text" height={20} width="60%" sx={{ mx: "auto" }} />
                </CardContent>
            </Card>

            {/* Optional caption skeleton under the card (if you show labels outside) */}
            <Box sx={{ mt: 1, textAlign: "center" }}>
                <Skeleton animation="wave" variant="text" height={18} width="60%" sx={{ mx: "auto" }} />
            </Box>
        </Box>
    );
}

function ServiceImageCard({
    imgSrc,
    imgAlt = "service",
    ratio = "5 / 4",
    radius = 14,
    title,
    href,
    scrollToHero,
    router,
    target,
    disable, openEnquire, setOpenEnquire
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    // autoclose the popover after 1.5s
    React.useEffect(() => {
        if (!open) return;
        const t = setTimeout(() => setAnchorEl(null), 1500);
        return () => clearTimeout(t);
    }, [open]);

    const handleOpenEnquire = () => setOpenEnquire(true)

    const handleActivate = (e) => {
        if (disable) {
            setAnchorEl((e.currentTarget) || null);
            return;
        }

        if (href) {
            if (target) {
                window.open(href, "_blank", "noopener,noreferrer");
            } else {
                router.push(href);
            }
        } else {
            if (title === "Rides" || title === "Hourly") scrollToHero(title);
            if (title === "Your Personal Chauffeur") handleOpenEnquire();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleActivate(e);
        }
    };

    return (
        <>
            <Paper
                elevation={0}
                role="button"
                tabIndex={0}
                aria-disabled={disable ? "true" : "false"}
                onClick={handleActivate}
                onMouseUp={handleActivate}
                onKeyDown={handleKeyDown}
                sx={{
                    width: "100%",
                    overflow: "hidden",
                    bgcolor: "#fff",
                    cursor: disable ? "not-allowed" : "pointer",
                    outline: "none",
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        aspectRatio: ratio,
                        p: 1,
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                            transform: !disable && "scale(1.03)",
                            boxShadow: !disable && "0 4px 20px rgba(0,0,0,0.1)",
                        },
                        // opacity: disable ? 0.7 : 1,
                    }}
                >
                    {imgSrc && (
                        <Image
                            src={imgSrc}
                            alt={imgAlt}
                            fill
                            style={{ objectFit: "contain", display: "block" }}
                            sizes="(max-width: 768px) 100vw, 320px"
                            priority
                        />
                    )}
                </Box>

                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: { xs: 14, md: 16 },
                        lineHeight: 1.3,
                        textAlign: "center",
                        color: "#111",
                        whiteSpace: "pre-line",
                        mt: 0.5,
                        mb: 0,
                    }}
                >
                    {title}
                </Typography>
            </Paper>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                PaperProps={{
                    sx: { px: 1.5, py: 1, borderRadius: 2 },
                    elevation: 3,
                }}
            >
                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                    Coming soon
                </Typography>
            </Popover>
        </>
    );
}




// function ServiceImageCard({
//     imgSrc,
//     imgAlt = "service",
//     ratio = "5 / 4",
//     radius = 22,
//     children, title

// }) {
//     return (
//         <Paper
//             elevation={0}
//             sx={{
//                 width: "100%",
//                 // borderRadius: radius,
//                 // overflow: "hidden",
//                 // position: "relative",
//                 // // exact background look
//                 // background:
//                 //     "linear-gradient(180deg, #f4f8f8 0%, #eef4f4 50%, #edf3f3 100%)",
//                 // border: "1px solid #E6EDF3",
//                 // boxShadow: "0 6px 18px rgba(13,139,146,.08)",
//                 // // teal “light” at the top
//                 // "&::before": {
//                 //     content: '""',
//                 //     position: "absolute",
//                 //     inset: 0,
//                 //     borderRadius: radius,
//                 //     background:
//                 //         "radial-gradient(80% 70% at 50% 0%, rgba(36,202,193,.28) 0%, rgba(36,202,193,0) 70%)",
//                 //     pointerEvents: "none",
//                 // },
//             }}
//         >
//             {/* Content area with fixed aspect ratio so all cards match */}
//             <Box sx={{ position: "relative", aspectRatio: ratio }}>
//                 {children ? (
//                     children
//                 ) : imgSrc ? (
//                     <Image
//                         src={imgSrc}
//                         alt={imgAlt}
//                         fill
//                         style={{ objectFit: "contain", display: "block" }}
//                         sizes="(max-width: 768px) 100vw, 320px"
//                         priority
//                     />
//                 ) : null}
//             </Box>
//             <Typography
//                 sx={{
//                     fontFamily: "Inter, system-ui, sans-serif",
//                     fontWeight: 700,
//                     fontSize: { xs: 18, md: 20 },
//                     lineHeight: 1.25,
//                     textAlign: "center",
//                     color: "#111",
//                     whiteSpace: "normal",
//                     display: "-webkit-box",
//                     WebkitBoxOrient: "vertical",
//                     WebkitLineClamp: 2,
//                     overflow: "hidden",
//                     mt: 1,
//                     minHeight: { xs: 44, md: 48 },     // ⬅️ equal caption height across cards
//                 }}
//             >
//                 {title}
//             </Typography>
//         </Paper>
//     );
// }

// function ServiceCard({ title, img }) {
//     return (
//         <Stack alignItems="center" spacing={1.75}>
//             <Paper
//                 elevation={0}
//                 sx={{
//                     width: "100%",
//                     height: { xs: 188, md: 200 },      // ⬅️ same card height for all
//                     p: { xs: 2.5, md: 2 },             // ⬅️ equal inner padding for all
//                     borderRadius: "22px",
//                     position: "relative",
//                     overflow: "hidden",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     background:
//                         "linear-gradient(180deg, #f4f8f8 0%, #eef4f4 50%, #edf3f3 100%)",
//                     transition: "transform .18s ease, box-shadow .18s ease",
//                     "&:hover": { transform: "translateY(-2px)" },

//                     // green light glow on top
//                     "&::before": {
//                         content: '""',
//                         position: "absolute",
//                         inset: 0,
//                         borderRadius: "22px",
//                         background:
//                             "radial-gradient(80% 70% at 50% 0%, rgba(36, 202, 193, 0.25) 0%, rgba(36, 202, 193, 0) 100%)",
//                         pointerEvents: "none",
//                     },
//                 }}
//             >
//                 {/* Uniform image bounding box -> all images same visual size */}
//                 <Box
//                     sx={{
//                         position: "relative",
//                         width: { xs: 200, md: 220 },      // ⬅️ increase/decrease to taste
//                         height: { xs: 130, md: 145 },     // ⬅️ keeps proportions consistent
//                         maxWidth: "100%",
//                     }}
//                 >
//                     <Image src={img} alt={title} fill style={{ objectFit: "contain" }} />
//                 </Box>
//             </Paper>

//             {/* caption (fixed height so rows align even with 2-line titles) */}
//             <Typography
//                 sx={{
//                     fontFamily: "Inter, system-ui, sans-serif",
//                     fontWeight: 700,
//                     fontSize: { xs: 18, md: 20 },
//                     lineHeight: 1.25,
//                     textAlign: "center",
//                     color: "#111",
//                     whiteSpace: "normal",
//                     display: "-webkit-box",
//                     WebkitBoxOrient: "vertical",
//                     WebkitLineClamp: 2,
//                     overflow: "hidden",
//                     minHeight: { xs: 44, md: 48 },     // ⬅️ equal caption height across cards
//                 }}
//             >
//                 {title}
//             </Typography>
//         </Stack>
//     );
// }

function ServiceCard({ title, img, variant = "plain" }) {
    if (variant === "plain") {
        return (
            // smaller internal spacing to reduce vertical gap within a tile
            <Stack alignItems="center" spacing={{ xs: 0.75, md: 1 }}>
                <Box
                    sx={{
                        position: "relative",
                        width: { xs: 200, md: 220 },     // keep your visual size
                        height: { xs: 130, md: 150 },
                        overflow: "visible",
                    }}
                >
                    <Image
                        src={img}
                        alt={title || "service"}
                        fill
                        sizes="(max-width: 768px) 200px, 220px"
                        style={{ objectFit: "contain", display: "block" }}
                        priority
                    />
                </Box>

                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: 16, md: 18 },
                        lineHeight: 1.25,
                        textAlign: "center",
                        color: "#111",
                        whiteSpace: "pre-line",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        overflow: "hidden",
                        minHeight: { xs: 36, md: 40 },   // slightly tighter caption block
                    }}
                >
                    {title}
                </Typography>
            </Stack>
        );
    }
    return null;
}


